var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolSearchIcNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3451_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9424 47.3704C26.8867 43.6208 25.3424 40.6434 23.0593 38.427L29.2556 26.3338C30.386 26.6921 31.136 26.681 32.2608 26.6643C33.0108 26.6531 33.3857 26.6476 33.7607 26.642L38.7964 37.4435C36.2051 39.7322 34.3804 43.1346 34.4415 47.2592C34.5472 54.3834 40.6356 60.2938 47.7598 60.1881C54.884 60.0824 60.7943 53.9941 60.6887 46.8698C60.583 39.7456 54.4946 33.8353 47.3704 33.941C46.6205 33.9521 46.2456 33.9576 45.8706 33.9632L40.8348 23.1617C43.4262 20.873 45.2509 17.4706 45.1897 13.346C45.084 6.22182 38.9957 0.311476 31.8715 0.417155C24.7473 0.522835 18.8369 6.61117 18.9426 13.7354C18.9982 17.485 20.5426 20.4624 22.8257 22.6788L16.6238 34.3971C15.4989 34.4137 14.749 34.4249 13.6241 34.4415C6.49993 34.5472 0.589579 40.6356 0.695259 47.7598C0.800938 54.884 6.88927 60.7943 14.0135 60.6887C21.1377 60.583 27.048 54.4946 26.9424 47.3704ZM56.9391 46.9255C57.0169 52.1749 52.9536 56.3606 47.7042 56.4385C42.4547 56.5164 38.269 52.453 38.1911 47.2036C38.1133 41.9541 42.1766 37.7684 47.4261 37.6906C52.6755 37.6127 56.8612 41.676 56.9391 46.9255ZM22.6922 13.6798C22.6143 8.43034 26.6777 4.24461 31.9271 4.16674C37.1765 4.08887 41.3623 8.15224 41.4401 13.4017C41.518 18.6511 37.4546 22.8368 32.2052 22.9147C26.9558 22.9926 22.7701 18.9292 22.6922 13.6798ZM4.44485 47.7042C4.36698 42.4547 8.43034 38.269 13.6798 38.1911C18.9292 38.1133 23.1149 42.1766 23.1928 47.4261C23.2707 52.6755 19.2073 56.8612 13.9579 56.9391C8.70844 57.0169 4.52272 52.9536 4.44485 47.7042Z",
    fill: "#FFB629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3451_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(59.9934) rotate(89.1501)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolSearchIcNetwork);
export default __webpack_public_path__ + "static/media/sol-search-ic-network.23a4fbbfad863a45c4c507903c361b16.svg";
export { ForwardRef as ReactComponent };